/** The board's 3 · 2 · 1 (unit convention §1). */
import React from 'react';

import {useBoardCountdownModel} from './model';
import BoardCountdownView from './View';

export default React.memo(function BoardCountdown() {
  return <BoardCountdownView {...useBoardCountdownModel()} />;
});
